module.exports = __webpack_public_path__ + "static/media/player_lock.87d0906b.png";